"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CustomerIcon = function CustomerIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "32",
    height: "33",
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "16",
    cy: "16.6509",
    r: "16",
    fill: "#D28F3B",
    fillOpacity: "0.3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 18.0692C18.7614 18.0692 21 15.8306 21 13.0692C21 10.3078 18.7614 8.06921 16 8.06921C13.2386 8.06921 11 10.3078 11 13.0692C11 15.8306 13.2386 18.0692 16 18.0692Z",
    stroke: "#D28F3B",
    strokeWidth: "1.5",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.42102 22.4435C9.18943 21.1135 10.2943 20.0091 11.6247 19.2412C12.955 18.4734 14.464 18.0692 16.0001 18.0692C17.5361 18.0692 19.0451 18.4735 20.3755 19.2413C21.7058 20.0092 22.8107 21.1136 23.5791 22.4436",
    stroke: "#D28F3B",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var _default = CustomerIcon;
exports["default"] = _default;